module.exports = __webpack_public_path__ + "img/banner1.564f6b1f.png";